import { makeRequest } from 'utils/requestLogger';

export default (discussion_id, user_id, turn_id) =>
  makeRequest(
    'put',
    `/api/live_discussions/${discussion_id}/leave_queue/${user_id}`, { turn_id }
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/queue/leaveQueue.js